import { Box, Stack, useTheme } from '@mui/material'
import { useGetProjectForMap } from 'src/api/project'
import { MapComponent } from '../localities/components/map/MapComponent'
import { IProjectInfo } from 'src/generated-types/project'
import EmptyMap from '../localities/components/map/EmptyMap'
import { Spinner } from 'src/components/Spinner'

const ProjectMapComponent: React.FC<{
  customerId: EntityId
  localityId: EntityId
  projectId: EntityId
  height: number | string
  display?: 'block' | 'none'
  fitAllPositions?: boolean
}> = ({ customerId, localityId, projectId, height, display, fitAllPositions }) => {
  const theme = useTheme()
  const { data: project, isLoading } = useGetProjectForMap(
    customerId as EntityId,
    localityId as EntityId,
    projectId as EntityId,
  )

  return (
    <Box
      height={height}
      borderRadius={'8px'}
      boxShadow={`0px 2px 8px ${theme.palette.transparentBlack[theme.palette.mode]}`}
      position={'relative'}
      display={display}
    >
      {isLoading ? (
        <Stack
          direction={'column'}
          justifyContent={'center'}
          alignItems={'center'}
          minHeight={'100%'}
          data-test-id="map-loading"
        >
          <Spinner />
        </Stack>
      ) : project != undefined ? (
        <MapComponent
          layerControl={false}
          navigateLocalityWhenClick={false}
          projects={[project] as IProjectInfo[]}
          key={'project-map'}
          zoomControl={false}
          scrollWheelZoom={false}
          showCageStatusPopOver={false}
          showEnlargeIcon={false}
          fitAllPositions={fitAllPositions}
        />
      ) : (
        <EmptyMap />
      )}
    </Box>
  )
}

export default ProjectMapComponent
